module.exports = __webpack_public_path__ + "419b80fc.png";